import { kvkk } from './kvkk';
import { privacy } from './privacy';
import { cookiePolicy } from './cookies';

export const LEGAL_DOCS = [
  { key: 'kvkk', path: '/kvkk', content: kvkk, label: { tr: 'KVKK Aydınlatma Metni', en: 'KVKK Notice' } },
  { key: 'privacy', path: '/gizlilik-politikasi', content: privacy, label: { tr: 'Gizlilik Politikası', en: 'Privacy Policy' } },
  { key: 'cookies', path: '/cerez-politikasi', content: cookiePolicy, label: { tr: 'Çerez Politikası', en: 'Cookie Policy' } },
];
